import React, { useState, useEffect } from "react";
import { Avatar, Skeleton } from "@mui/material";
import ProfileImg from "../../assets/default/user.jpg";

const UserProfileImage = ({ user, size = "default", className = "", showSkeleton = true, alt = "User profile" }) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // Reset loading state when user or picture changes
  useEffect(() => {
    if (user?.picture) {
      console.log(`UserProfileImage: Starting to load image for ${user.username}: ${user.picture}`);
      setImageLoading(true);
      setImageError(false);
    }
  }, [user?.picture]);

  // If no user data, show skeleton
  if (!user) {
    return showSkeleton ? <Skeleton variant="circular" className={className} /> : null;
  }

  // If user has no picture, show default
  if (!user.picture) {
    return (
      <Avatar
        src={ProfileImg}
        alt={alt}
        className={className}
        sx={{ width: "auto", height: "auto", position: "relative", display: "block" }}
      />
    );
  }

  // If image failed to load, show default
  if (imageError) {
    return (
      <Avatar
        src={ProfileImg}
        alt={alt}
        className={className}
        sx={{ width: "auto", height: "auto", position: "relative", display: "block" }}
      />
    );
  }

  // Show Avatar with skeleton overlay while loading
  // Check if className contains absolute positioning
  const hasAbsolutePositioning = className.includes("absolute");

  return (
    <div className={hasAbsolutePositioning ? className : `relative ${className}`}>
      <Avatar
        src={user.picture}
        alt={alt}
        className="w-full h-full"
        sx={{
          width: "auto",
          height: "auto",
          position: "relative", // Ensure Avatar doesn't interfere with absolute positioning
          display: "block", // Ensure proper display behavior
        }}
        onLoad={() => {
          console.log(`UserProfileImage: Image loaded successfully for ${user.username}`);
          setImageLoading(false);
        }}
        onError={() => {
          console.log(`UserProfileImage: Image failed to load for ${user.username}: ${user.picture}`);
          setImageLoading(false);
          setImageError(true);
        }}
      />
      {imageLoading && showSkeleton && <Skeleton variant="circular" className="absolute inset-0 w-full h-full" />}
    </div>
  );
};

export default UserProfileImage;
